export enum SORT_KEYS {
  name = 'name',
  role = 'role',
  lastLogin = 'last_login',
}

export type sortStateType = {
  key: string;
  state: number;
} | null;

export const USER_ROLES_NAMES = {
  company_owner: 'ownerRole',
  team_manager: 'managerRole',
  b2b_learner: 'memberRole',
};
